import { render, staticRenderFns } from "./TableCustomRender.vue?vue&type=template&id=c4db5978"
import script from "./TableCustomRender.vue?vue&type=script&lang=js"
export * from "./TableCustomRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports